import { render } from "./SVGMinusButton.vue?vue&type=template&id=f18f84d8"
import script from "./SVGMinusButton.vue?vue&type=script&lang=js"
export * from "./SVGMinusButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__